import Email from 'api/models/Engines/Email';

const dataToCopyTextMapper = (data: Email) => {
	return data;
};

export default dataToCopyTextMapper;
